import React, {useState} from 'react';

const ListItemDiscount = ({ item, selected, handleCheck }) => {
    const currencyFormatter = new Intl.NumberFormat('en-US', {
        style: "currency",
        currency: "CAD",
        minimumFractionDigits: 2
    });

  return (
                  <tr>
                      <th scope="row">
                          <div className="d-flex align-items-center">
                              <input
                                  className="form-check-input m-0 me-3 border-secondary shadow-sm"
                                  style={{ cursor: 'pointer', width: '1.25em', height: '1.25em' }}
                                  type="radio"
                                  name="itemSelection"
                                  checked={selected}
                                  onChange={() => handleCheck(item)}
                              />
                              <span className="fw-bold" style={{ cursor: 'pointer' }} onClick={() => handleCheck(item)}>
                                  {item.clientName}
                              </span>
                          </div>
                      </th>
                      <td>{item.subName}</td>
                      <td>{currencyFormatter.format(item.subPrice)}</td>
                      <td>{item.subTax}%</td>
                      <td>{item.subDiscount}</td>
                  </tr>
  );
}

export default ListItemDiscount;